import React, { forwardRef, memo, useEffect } from "react";

import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";
import Loader from "../orderStatus/Loader";

const Inquiries = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex flex-row">
        <div className="flex flex-col mt-[60px] w-full">
          <div className="flex flex-row justify-between m-auto mb-[48px] mt-10 my-4 w-[1060px]">
            <div className="flex flex-col gap-[16px] justify-start pb-[40px] w-full">
              <h1 className="font-[700] font-montserrat leading-[26.82px] text-[22px]">
                {" "}
                {t("inquiriesHeading")}
              </h1>

              <p className="font-[400] leading-[21.79px] text-[16px]">
                {t("descriptionText")}
              </p>
            </div>
            <div className="flex flex-col ">
              <>
                <div className="mb-4">
                  <Link to={`/dashboard`}>
                    <button
                      className="flex float-right font-semibold w-max px-[10px]"
                      type="button"
                    >
                      <img className="mr-2 mt-0" src="\Images\arrow-left.svg" />
                      {t('back')}
                    </button>
                  </Link>
                </div>
              </>
            </div>
          </div>
          <div className="border border-box-stroke form-container m-auto mb-[48px] my-4 py-8 w-[1060px] rounded-sm">
            <div style={{ marginTop: 10, marginLeft: 30 }}>
              <p className="font-[400] leading-[21.79px] text-[16px]">
                <a
                  href="https://fnfms.sharepoint.com/:b:/s/FNFCanada/IT/Eb8-8kxTGldFpNCGPahy17kB6O9DTf0PK2_mw8thZYGivA?e=PCB9Pg"
                  className="underline focus-visible:outline-none focus:outline-none text-shadow "
                >
                  Residential Title Insurance Inquiry - ENG
                </a>
              </p>
            </div>
            <div style={{ marginTop: 9, marginLeft: 30 }}>
              <p className="font-[400] leading-[21.79px] text-[16px]">
                <a
                  href="https://fnfms.sharepoint.com/:b:/s/FNFCanada/IT/EQeKPNuum3xEmnhjQp7eUOMB8sj0Qj0HsTMK0TnykPvibw?e=NQ5InH"
                  className="underline focus-visible:outline-none focus:outline-none text-shadow "
                >
                  Residential Title Insurance Inquiry - FR
                </a>
              </p>
            </div>
            <div style={{ marginTop: 9, marginLeft: 30 }}>
              <p className="font-[400] leading-[21.79px] text-[16px]">
                <a
                  href="https://fnfms.sharepoint.com/:b:/s/FNFCanada/IT/ESA22bJbJglPplNtegp-g7oBGWyPFbZJOqw1sTGbwHOvZw?e=g6UjsD"
                  className="underline focus-visible:outline-none focus:outline-none text-shadow "
                >
                  Commercial Title Insurance Inquiry - ENG
                </a>
              </p>
            </div>
            <div style={{ marginTop: 9, marginLeft: 30, marginBottom: 50 }}>
              <p className="font-[400] leading-[21.79px] text-[16px]">
                <a
                  href="https://fnfms.sharepoint.com/:b:/s/FNFCanada/IT/EStE7ONa_zJGhmPtnLVJY4QBcaKtt9-PQor0YFLxBPNYdg?e=6QDKK4"
                  className="underline focus-visible:outline-none focus:outline-none text-shadow "
                >
                  Commercial Title Insurance Inquiry - FR
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(Inquiries);
